import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/buttons.css';
import './styles/forms.css';
import './styles/board.css';
import './styles/controls.css';
import './styles/result.css';
import './styles/sharing.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import { leaveOldAddress } from './app/leave.tsx';
import { initTheme } from './app/theme.ts';
import { consumeCarryOnLaunch, initInstall } from './pwa/install.ts';
import { isLegacyOrigin } from './pwa/move.ts';
import { initNetwork } from './pwa/network.ts';
import { registerServiceWorker } from './pwa/register.ts';
import { stripPushParams, syncPush } from './push/push.ts';

// On the old address (workers.dev), the app doesn't start: it hands the player's data over
// to sparrowword.com and goes there (pwa/move.ts). Nothing below runs, so it registers no
// service worker and sends nothing.
const legacy = typeof window !== 'undefined' && isLegacyOrigin(window.location.origin);
const rootEl = document.getElementById('root');
if (legacy) {
	if (rootEl) void leaveOldAddress(rootEl);
} else {
	// Before anything else: Chrome's install prompt arrives early and must be caught.
	initInstall();
	// Older service workers precached the manifest, so Android kept reading a stale copy (light
	// paper) when installing. Drop any cached copy; the worker then fetches it from the network.
	if (typeof caches !== 'undefined') {
		void caches
			.keys()
			.then((names) => Promise.all(names.map((n) => caches.open(n).then((c) => c.delete('/manifest.webmanifest')))))
			.catch(() => undefined);
	}
	initNetwork();
	// Settings → Theme (index.html already set it before the first paint; this keeps it in step).
	initTheme();
	registerServiceWorker();

	const root = rootEl;
	if (root) {
		// A first launch from the home screen may bring a carry code (the streak, from
		// Safari): merge it before the app reads storage. At most a few seconds, once.
		void consumeCarryOnLaunch().then(() => {
			stripPushParams();
			// Notifications on here: check the subscription is still alive, and the zone (later, off the launch path).
			window.setTimeout(() => void syncPush(), 4000);
			createRoot(root).render(
				<StrictMode>
					<App />
				</StrictMode>,
			);
		});
	}
}
